<template>
  <div>
    <Layout>
      <template v-slot:left>
        <ButtonBackList :toUrl="toUrl" />
        <ButtonGetLink @click="openURLLinkModal" />
        <ButtonSave
          :form="form"
          @toggleIsRegistering="$emit('toggleIsRegistering')"
        />
      </template>
      <template v-slot:right>
        <ButtonPrev />
        <ButtonNext :form="form" />
      </template>
    </Layout>
    <SimulationUrlLinkModal
      @cancel="closeURLLinkModal"
      v-if="isShowURLLinkModal"
      :visible="isShowURLLinkModal"
      :hash-id="hashId"
      :simulation-id="simulationId"
    />
  </div>
</template>

<script>
import ButtonNext from '@/components/Shared/Simulation/SimulationFooterButtonNext'
import ButtonPrev from '@/components/Shared/Simulation/SimulationFooterButtonPrev'
import ButtonBackList from '@/components/Shared/Simulation/SimulationFooterButtonBackList'
import ButtonGetLink from '@/components/Shared/Simulation/SimulationFooterEditButtonGetLink'
import ButtonSave from '@/components/Shared/Simulation/SimulationFooterEditButtonSave'
import Layout from '@/components/Shared/Simulation/SimulationFooterLayout'
import SimulationUrlLinkModal from '@/components/Shared/Simulation/SimulationUrlLinkModal'

export default {
  name: 'SimulationFooterEdit',
  components: {
    SimulationUrlLinkModal,
    ButtonNext,
    ButtonPrev,
    ButtonBackList,
    ButtonGetLink,
    ButtonSave,
    Layout,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toUrl: '../../simulations',
      isShowURLLinkModal: false,
      isShowSaveAsNameModal: false,
    }
  },
  computed: {
    hashId() {
      return this.form.basicSetting.hashId
    },
    simulationId() {
      return this.form.basicSetting.id
    },
  },
  methods: {
    openURLLinkModal() {
      this.isShowURLLinkModal = true
    },
    closeURLLinkModal() {
      this.isShowURLLinkModal = false
    },
  },
}
</script>

<style scoped>
.buttons {
  margin: 5px 10px;
}
</style>
